
const mapMessage = (message: any, protocol: string) => {


    const channel2Action: Record<string, any> = {
        "ThermUpstairsBathActual": { action: 'updateActual',deviceType:'room' },
        "ThermGuestRoomActual": { action: 'updateActual',deviceType:'room' },
        "ThermParentRoomActual": { action: 'updateActual',deviceType:'room' },
        "ThermKidsRoomActual": { action: 'updateActual',deviceType:'room' },
        'ThermBathActual': { action: 'updateActual',deviceType:'room' },
        'ThermUpstairsActual': { action: 'updateActual',deviceType:'room' },
        "ThermUpstairsBathTarget": { action: 'updateTarget',deviceType:'room' },
        "ThermGuestRoomTarget": { action: 'updateTarget',deviceType:'room' },
        "ThermParentsTarget": { action: 'updateTarget',deviceType:'room' },
        "ThermKidsRoomTarget": { action: 'updateTarget',deviceType:'room' },
        'ThermBathTarget': { action: 'updateTarget',deviceType:'room' },
        'ThermUpstairsTarget': { action: 'updateTarget',deviceType:'room' },
        'L1-1': {action: 'switchHeater',deviceType:'room'},
        'L1-2': {action: 'switchHeater',deviceType:'room'},
        'L1-3': {action: 'switchHeater',deviceType:'room'},
        'L1-4': {action: 'switchHeater',deviceType:'room'},
        'L2-1': {action: 'switchHeater',deviceType:'room'},
        'L2-2': {action: 'switchHeater',deviceType:'room'},
        'L2-3': {action: 'switchHeater',deviceType:'room'},
        'L2-4': {action: 'switchHeater',deviceType:'room'},
        'L3-1': {action: 'switchHeater',deviceType:'room'},
        'L3-2': {action: 'switchHeater',deviceType:'room'},
        'L3-3': {action: 'switchHeater',deviceType:'room'},
        'L3-4': {action: 'switchHeater',deviceType:'room'},
        'Boiler': {action: 'updateStatus',deviceType:'heating'},
        'Fireplace Circulation': {action: 'updateStatus',deviceType:'heating'},
        'FloorHeatingPump': {action: 'updateStatus',deviceType:'heating'},
        'ZoneValve': {action: 'updateStatus',deviceType:'heating'}
    }

    var deviceId: string = ""
    var roomId: string = ""
    var value: string = "none"
    var action: string = ""
    var dtype: string | null = null


    //console.log(protocol)
    switch (protocol) {
        case 'BidCos-RF': case 'HmIP-RF': {
            const channelName = message.payload[1].channelName
            //console.log(channelName)

            roomId = message.payload[1].room
            deviceId =  message.payload[1].deviceName
            if (Object.hasOwn(channel2Action, channelName)) {
                action = channel2Action[channelName].action
                dtype = channel2Action[channelName].deviceType
            }
            
            if (Object.hasOwn(message.payload[0], 'TEMPERATURE')) {
                value = message.payload[0].TEMPERATURE
            }

            if (Object.hasOwn(message.payload[0], 'STATE')) {
                value = message.payload[0].STATE
            }

            if (Object.hasOwn(message.payload[0], 'SETPOINT')) {
                value = message.payload[0].SETPOINT
            }

            if (deviceId == 'HeatingSwitch') {
                deviceId = channelName
            }

            //console.log('mapMessage->',{ roomId, deviceId, action, value, dtype })
            return { roomId, deviceId, action, value, dtype }
        }
        case 'vbus': {
            deviceId = "1"
            const action = "updateState"
            const value = 0
            return { roomId: "", deviceId, action, value, dtype }
        }
        default: {
            return { roomId: "", deviceId: "", action: "", value,  dtype }
        }
    }


}

export default mapMessage